import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { authProvider } from './authProvider';
import AzureAD from 'react-aad-msal';


const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

if (params.fullName) {
  sessionStorage.setItem("fullName", params.fullName);
}
if (params.callId) {
  sessionStorage.setItem("callId", params.callId);
}
if (params.clientNumber) {
  sessionStorage.setItem("clientNumber", params.clientNumber);
}
if (params.captureCVV) {
  sessionStorage.setItem("captureCVV", params.captureCVV);
}
if (params.captureExpiry) {
  sessionStorage.setItem("captureExpiry", params.captureExpiry);
}
if (params.acceptedCC) {
  sessionStorage.setItem("acceptedCC", params.acceptedCC);
}

ReactDOM.render(
  <AzureAD provider={authProvider} forceLogin={true} >
    <App />
  </AzureAD>,
  document.getElementById('root'),
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
